import Matrice4E from '../../images/products/drone/Matrice4E.png';
import Matrice400 from '../../images/products/drone/Matrice400.png';
import Mavic3M from '../../images/products/drone/Mavic3M.png';
import Mavic3 from '../../images/products/drone/Mavic3.png';
import Fixar700 from '../../images/products/drone/Fixar700.png';
import HEQ from '../../images/products/drone/HEQ.png';
import Module_26MP from '../../images/products/sensor/Module_26MP.png';
import Module_45MP from '../../images/products/sensor/Module_45MP.png';
import Module_61MP from '../../images/products/sensor/Module_61MP.png';
import Module_102MP from '../../images/products/sensor/Module_102MP.png';
import PSDK_102S_V3 from '../../images/products/sensor/PSDK_102S_V3.png';
import SHARE_105S_PRO from '../../images/products/sensor/SHARE_105S_PRO.png';
import SHARE_205S_PRO from '../../images/products/sensor/SHARE_205S_PRO.png';
import SHARE_230S_PRO from '../../images/products/sensor/SHARE_230S_PRO.png';
import SHARE_304S_PRO from '../../images/products/sensor/SHARE_304S_PRO.png';
import SHARE_305S_PRO from '../../images/products/sensor/SHARE_305S_PRO.png';
import SHARE_505S_PRO from '../../images/products/sensor/SHARE_505S_PRO.png';
import SHARE_S20 from '../../images/products/sensor/SHARE_S20.png';
import SHARE_T2 from '../../images/products/sensor/SHARE_T2.png';
import SHARE_SLAM_S100 from '../../images/products/sensor/SHARE_SLAM_S100.png';
import BL_CH4 from '../../images/products/sensor/BL_CH4.png';
import CHCNAV_i93 from '../../images/products/sensor/CHCNAV_i93.png';
import CHCNAV_RS10 from '../../images/products/sensor/CHCNAV_RS10.png';
import BL_CH4_MINI from '../../images/products/sensor/BL_CH4_MINI.png';
import Tundra_Drone_Automoving from '../../images/products/sensor/Tundra_Drone_Automoving.png';
import XYZ_SFAIRA_ONE_PLUS_GNSS_RECEIVER from '../../images/products/gnss/XYZ_SFAIRA_ONE_PLUS_GNSS_RECEIVER.png';
import XYZ_X1_GNSS_Receiver from '../../images/products/gnss/XYZ_X1_GNSS_Receiver.png';

export const imageData = {
  DRONE: [
    {
      src: Matrice4E,
      name: 'Matrice 4E',
      description: '고성능 산업용 드론',
      link: 'https://example.com/droneA1',
    },
    {
      src: Matrice400,
      name: 'Matrice 400',
      description: '촬영용 드론',
      link: 'https://example.com/droneB2',
    },
    {
      src: Mavic3M,
      name: 'Mavic 3M',
      description: '장거리 비행 드론',
      link: 'https://example.com/droneC3',
    },
    {
      src: Mavic3,
      name: 'Mavic 3',
      description: '측량 전용 드론',
      link: 'https://example.com/droneD4',
    },
    {
      src: Fixar700,
      name: 'FIXAR-007',
      description: '소형 드론',
      link: 'https://example.com/droneE5',
    },
    {
      src: HEQ,
      name: 'HEQ',
      description: '방재 드론',
      link: 'https://example.com/droneF6',
    },
  ],
  SENSOR: [
    {
      src: SHARE_SLAM_S100,
      name: 'S100 Series (16 / 32 / 32 PRO)',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_S20,
      name: 'S20',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_105S_PRO,
      name: '105S PRO',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_205S_PRO,
      name: '205S PRO',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_305S_PRO,
      name: '305S PRO',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_505S_PRO,
      name: '505S PRO',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: Module_26MP,
      name: 'Module 26MP',
      description: '온습도 센서',
      link: 'https://example.com/sensorS1',
    },
    {
      src: Module_45MP,
      name: 'Module 45MP',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: Module_61MP,
      name: 'Module 61MP',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: Module_102MP,
      name: 'Module 102MP',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: BL_CH4_MINI,
      name: 'CH4 MINI',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: BL_CH4,
      name: 'CH4',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: CHCNAV_i93,
      name: 'i93',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: CHCNAV_RS10,
      name: 'RS10',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: Tundra_Drone_Automoving,
      name: 'Automoving Light Sensor',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: PSDK_102S_V3,
      name: '102S V3',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_230S_PRO,
      name: '230S PRO',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },

    {
      src: SHARE_304S_PRO,
      name: '304S PRO',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
    {
      src: SHARE_T2,
      name: 'T2',
      description: '가스 감지 센서',
      link: 'https://example.com/sensorS2',
    },
  ],
  GNSS: [
    {
      src: XYZ_X1_GNSS_Receiver,
      name: 'X1 GNSS Receiver',
      description: '고정밀 위치 측정',
      link: 'https://example.com/gnssG1',
    },
    {
      src: XYZ_SFAIRA_ONE_PLUS_GNSS_RECEIVER,
      name: 'SFAIRA ONE PLUS GNSS RECEIVER',
      description: '고정밀 위치 측정',
      link: 'https://example.com/gnssG1',
    },
  ],
};
